export default __webpack_public_path__ + "static/media/leg-icon-dining.48ca035f.png";